import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
// import { LinkContainer } from 'react-router-bootstrap';
import { Row, Col } from 'reactstrap';
// Local Deps
import './SearchUsers.scss';
// import { addUserRoute } from '../../config/navigation/routes';
import msgs from '../../../config/messages';
import SearchUsersHOC from './SearchUsersHOC';
import ViewUsersGrid from '../../../components/grids/ViewUsersGrid';
// import NFButton from '../../components/primitives/NFButton';
import Loading from '../../../components/Loading';

function ViewUsers({
  auth,
  users,
  isLoading,
  refreshUsers,
  organizationsStatus,
  organizationsName,
  organizationsCage,
}) {
  console.log({
    auth,
    users,
    isLoading,
    refreshUsers,
    organizationsStatus,
    organizationsName,
    organizationsCage,
  });
  return (
    <div className="nf-view-users">
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Search Users Page</title>
      </Helmet>
      <Row>
        <Col style={{ padding: 0 }}>
          {/* <!-- LOADING --> */}
          {isLoading && <Loading text={msgs.ViewUsers.loading} />}

          {/* <!-- CONTENT --> */}
          {!isLoading && (
            <div className="nf-view-users__content">
              <Row className="nf-row--justify-end" />
              {/* <!-- USERS GRID --> */}
              <div className="nf-view-users__grid">
                <ViewUsersGrid
                  users={users}
                  SuperAdmin
                  refreshUsers={refreshUsers}
                  organizationsStatus={organizationsStatus}
                  organizationsName={organizationsName}
                  organizationsCage={organizationsCage}
                  auth={auth}
                />
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}

ViewUsers.propTypes = {
  auth: PropTypes.shape({
    jwtToken: PropTypes.string.isRequired,
    expiration: PropTypes.number.isRequired,
    organizationId: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
  }).isRequired,
  users: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  refreshUsers: PropTypes.func.isRequired,
  organizationsStatus: PropTypes.string.isRequired,
  organizationsName: PropTypes.string.isRequired,
  organizationsCage: PropTypes.string.isRequired,
};

ViewUsers.defaultProps = {
  users: [],
};

export default SearchUsersHOC(ViewUsers);



// WEBPACK FOOTER //
// ./src/pages/SuperAdminHome/SearchUsers/SearchUsers.jsx